import { Tab, Tabs } from '@ph-react-ui/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { FoodPaymentNotificationSettings } from './FoodPaymentNotificationSettings';
import { SchoolPaymentNotificationSettings } from './SchoolPaymentNotificationSettings';

export function EmailNotificationSettings() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabSelected, setTabSelected] = useState<string | number>(
    searchParams.get('tab') ?? 'payment-email-notifications'
  );

  return (
    <div className="email-notification-settings py-4 px-8">
      <Tabs
        selected={tabSelected}
        onSelectedChange={(selected) => {
          setTabSelected(selected);
          setSearchParams({ tab: selected.toString() });
        }}
      >
        {[
          <Tab
            key="payment-email-notifications"
            id="payment-email-notifications"
            title={t('SETTINGS.TABS.PAYMENT_EMAIL_NOTIFICATIONS')}
          >
            <SchoolPaymentNotificationSettings />
          </Tab>,

          <Tab
            key="food-email-notifications"
            id="food-email-notifications"
            title={t('SETTINGS.TABS.FOOD_EMAIL_NOTIFICATIONS')}
          >
            <FoodPaymentNotificationSettings />
          </Tab>,

          // OTHER tabs will be added here...
        ]}
      </Tabs>
    </div>
  );
}
